import loadable from '@loadable/component';

export const OrgDashboardIntegrationPartnerResourcesLoadable = loadable(
  () => import('./OrgDashboardIntegrationPartnerResources'),
  {
    resolveComponent: (module) =>
      module.OrgDashboardIntegrationPartnerResources,
  },
);
